import ShopifySurfacePickUp from '@pixelunion/shopify-surface-pick-up';
import Modal from '../components/Modal';

export default class SurfacePickUp {
  constructor({
    el,
    product,
    initialVariantId,
    hasOnlyDefaultVariant,
  }) {
    this.el = el;
    this.product = product;
    this.selectedVariant = product.variants.find(({ id }) => id === initialVariantId);

    const surfacePickUpEl = this.el.querySelector('[data-surface-pick-up]');
    const surfacePickUpElMobile = this.el.querySelector('[data-surface-pick-up-mobile]');

    this.surfacePickUps = [new ShopifySurfacePickUp(surfacePickUpEl)];

    if (surfacePickUpElMobile) {
      this.surfacePickUps.push(new ShopifySurfacePickUp(surfacePickUpElMobile));
    }

    const onModalRequest = content => {
      const variantTitle = hasOnlyDefaultVariant
        ? ''
        : `<div class="modal-header__surface-pick-up-variant">${this.selectedVariant.title}</div>`;

      const header = `
          <h2 class="modal-header__surface-pick-up-title">${product.title}</h2>
          ${variantTitle}
        `;

      Modal.open({ header, content });
    };

    this.surfacePickUps.forEach(surfacePickUp => {
      surfacePickUp.load(this.selectedVariant.id);
      surfacePickUp.onModalRequest(onModalRequest);
    });

    this.handleVariantChange = (event, data) => this.onVariantChange(data);

    $(window).on('product-variant-switch', this.handleVariantChange);
  }

  onVariantChange({ variant, isProduct }) {
    if (isProduct && !isProduct(this.product)) {
      return;
    }

    this.selectedVariant = variant;
    this.surfacePickUps.forEach(surfacePickUp => surfacePickUp.load(this.selectedVariant.id));
  }

  unload() {
    $(window).off('product-variant-switch', this.handleVariantChange);
    this.surfacePickUps.forEach(surfacePickUp => surfacePickUp.unload());
  }
}
